module.exports = __webpack_public_path__ + "img/horizontal_2_1_8019.c25429ad.png";